import { VStack } from '@chakra-ui/react';
import { EmailBlockSection } from '../../../components/EmailBlockSection';
import type { InterviewCommPanelBaseProps } from './types';
import { TemplatedEmail } from '../../../components/TemplatedEmail';

export const InterviewerCommunicationPanel = ({
  state,
  dispatch,
  fieldErrors,
  submitAttempt,
  interviewerCalendarTemplateOptions = [],
  interviewerEmailTemplateOptions = [],
  fromOptions,
  ccBccOptions,
  interviewerCalendarVariables,
  interviewerEmailVariables,
  uploadInlineImage,
  emailApiRefs,
}: InterviewCommPanelBaseProps) => (
  <VStack align="stretch" spacing="4" w="100%">
    <EmailBlockSection
      title="Interviewer's calendar invite"
      sectionId="interview-comm-interviewer-calendar"
    >
      <TemplatedEmail
        className="w-full"
        showFrom={false}
        showTo={false}
        showSubject={false}
        enableCcBcc={false}
        showTemplate
        showEditor
        editorVariant="calendarInvite"
        submitAttempt={submitAttempt}
        apiRef={emailApiRefs?.interviewerCalendar}
        variables={interviewerCalendarVariables}
        templateOptions={interviewerCalendarTemplateOptions}
        applyTemplateBodyToEditor
        value={state.interviewerCalendar}
        onChange={(value) =>
          dispatch({ type: 'SET_INTERVIEWER_CALENDAR', payload: value })
        }
        errors={fieldErrors.interviewerCalendar}
        placeholders={{ template: 'Select a template' }}
        uploadInlineImage={uploadInlineImage}
      />
    </EmailBlockSection>

    <EmailBlockSection
      title="Interviewer's email"
      sectionId="interview-comm-interviewer-email"
      showSwitch
      switchChecked={state.interviewerEmailEnabled}
      onSwitchChange={(checked) =>
        dispatch({ type: 'SET_INTERVIEWER_EMAIL_ENABLED', payload: checked })
      }
    >
      {state.interviewerEmailEnabled ? (
        <TemplatedEmail
          className="w-full"
          showFrom
          showTo={false}
          showSubject
          enableCcBcc
          showTemplate
          showEditor
          // ".ics" checkbox in the editor toolbar (kula `Email`
          // `showIcsCheckbox`); state rides on `value.ics`, mirrored to
          // `interviewerIcsEnabled`.
          showIcsCheckbox
          editorVariant="richEmail"
          submitAttempt={submitAttempt}
          apiRef={emailApiRefs?.interviewerEmail}
          variables={interviewerEmailVariables}
          attachments={state.interviewerEmailAttachments}
          onAttachmentsChange={(items) =>
            dispatch({
              type: 'SET_INTERVIEWER_EMAIL_ATTACHMENTS',
              payload: items,
            })
          }
          templateOptions={interviewerEmailTemplateOptions}
          fromOptions={fromOptions}
          ccBccOptions={ccBccOptions}
          applyTemplateBodyToEditor
          value={{
            ...state.interviewerEmail,
            ics: state.interviewerIcsEnabled,
          }}
          onChange={(value) => {
            dispatch({ type: 'SET_INTERVIEWER_EMAIL', payload: value });
            if (value.ics !== state.interviewerIcsEnabled) {
              dispatch({
                type: 'SET_INTERVIEWER_ICS_ENABLED',
                payload: value.ics,
              });
            }
          }}
          errors={fieldErrors.interviewerEmail}
          placeholders={{
            from: 'Select from',
            subject: 'Additional email for context',
            template: 'Select a template',
          }}
          uploadInlineImage={uploadInlineImage}
        />
      ) : null}
    </EmailBlockSection>
  </VStack>
);
